import api from './api';

const collectionsService = {
  // Collections CRUD
  getCollections: (params = {}) => {
    const { page = 1, limit = 10, sortBy = 'created_at', sortOrder = 'desc', status = 'all', search = '', collection_id } = params;
    return api.get('/admin/collections', {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        status,
        search,
        ...(collection_id ? { collection_id } : {}),
      },

    });
  },

  getCollectionById: (id) => api.get(`/admin/collections/${id}`),

  createCollection: (payload) => api.post('/admin/collections', payload),

  updateCollection: (id, payload) => api.put(`/admin/collections/${id}`, payload),

  deleteCollection: (id) => api.delete(`/admin/collections/${id}`),

  duplicateCollection: (id) => api.post(`/admin/collections/duplicate/${id}`),

  // Filters
  getFilters: (collectionId) => api.get(`/admin/collections/${collectionId}/filters`),

  upsertFilters: (collectionId, payload) => api.post(`/admin/collections/${collectionId}/filters`, payload),

  deleteFilters: (collectionId) => api.delete(`/admin/collections/${collectionId}/filters`),

  // Pinned items
  upsertPinnedItems: (collectionId, sortedItem) => api.post(`/admin/collections/${collectionId}/collection-pinned`, { sortedItem }),

  // Pinned collections listing
  getAllPinnedCollections: (params = {}) => {
    return api.get('/admin/collections/all/pinned', { params });
  },

  // Catalog for pinned tab (movies and tv series)

  // Pinned banners catalog
  getBannersForPinned: (args = {}) => {
    const {
      perPage = 20,
      currentPage = 1,
      searchText = '',
      collectionId,
    } = args || {};
    return api.get('/admin/collections/all-banners', {
      params: {
        perPage,
        currentPage,
        ...(searchText ? { search: searchText } : {}),
        ...(collectionId ? { collection_id: collectionId } : {}),
      },
    });
  },
  getMoviesForPinned: (args = {}) => {
    const {
      perPage = 20,
      currentPage = 1,
      searchText = '',
      // optional filters
      collectionId,
    } = args || {};
    return api.get('/admin/collections/video_show_for_movies', {
      params: {
        perPage,
        currentPage,
        ...(searchText ? { search: searchText } : {}),
        ...(collectionId ? { collection_id: collectionId } : {}),
      },
    });
  },

  getTvSeriesForPinned: (args = {}) => {
    const {
      perPage = 20,
      currentPage = 1,
      searchText = '',
      // optional filters
      collectionId,
    } = args || {};
    return api.get('/admin/collections/tv_show_series', {
      params: {
        perPage,
        currentPage,
        ...(searchText ? { search: searchText } : {}),
        ...(collectionId ? { collection_id: collectionId } : {}),
      },
    });
  },

  // SEO Meta
  upsertSeoMeta: (collectionId, payload) => api.post(`/admin/collections/${collectionId}/seo-meta`, payload),

  // User pinned toggle
  toggleUserPinned: (collectionId) => api.post(`/admin/collections/${collectionId}/pinned-user`),
};

export default collectionsService;
